<script setup lang="ts">
import { LocationTickIcon, PhoneIcon, MailIcon, FacebookIcon } from '@cfgtech/icons';

const dataLayer = useDataLayer();
const route = useRoute();

function handlePhoneClick() {
  if (route.path.includes('/auth/login')) {
    dataLayer.callClick(LocationsEnum.LOGIN_FOOTER);
  } else if (route.path.includes('/auth/register/password')) {
    dataLayer.callClick(LocationsEnum.REGISTER_PASSWORD_FOOTER);
  } else if (route.path.includes('/auth/register/confirm')) {
    dataLayer.callClick(LocationsEnum.REGISTER_CONFIRM_FOOTER);
  } else if (route.path.includes('/auth/register/success')) {
    dataLayer.callClick(LocationsEnum.REGISTER_SUCCESS_FOOTER);
  } else if (route.path.includes('/auth/register')) {
    dataLayer.callClick(LocationsEnum.REGISTER_FOOTER);
  } else if (route.path.includes('/auth/forgotten-password/success')) {
    dataLayer.callClick(LocationsEnum.FORGOTTEN_PASSWORD_SUCCESS_FOOTER);
  } else if (route.path.includes('/auth/forgotten-password')) {
    dataLayer.callClick(LocationsEnum.FORGOTTEN_PASSWORD_FOOTER);
  } else if (route.path.includes('/auth/reset-password')) {
    dataLayer.callClick(LocationsEnum.RESET_PASSWORD_FOOTER);
  } else {
    dataLayer.callClick(LocationsEnum.FOOTER);
  }
}

function handleEmailClick() {
  if (route.path.includes('/auth/login')) {
    dataLayer.emailClick(LocationsEnum.LOGIN_FOOTER);
  } else if (route.path.includes('/auth/register/password')) {
    dataLayer.emailClick(LocationsEnum.REGISTER_PASSWORD_FOOTER);
  } else if (route.path.includes('/auth/register/confirm')) {
    dataLayer.emailClick(LocationsEnum.REGISTER_CONFIRM_FOOTER);
  } else if (route.path.includes('/auth/register/success')) {
    dataLayer.emailClick(LocationsEnum.REGISTER_SUCCESS_FOOTER);
  } else if (route.path.includes('/auth/register')) {
    dataLayer.emailClick(LocationsEnum.REGISTER_FOOTER);
  } else if (route.path.includes('/auth/forgotten-password/success')) {
    dataLayer.emailClick(LocationsEnum.FORGOTTEN_PASSWORD_SUCCESS_FOOTER);
  } else if (route.path.includes('/auth/forgotten-password')) {
    dataLayer.emailClick(LocationsEnum.FORGOTTEN_PASSWORD_FOOTER);
  } else if (route.path.includes('/auth/reset-password')) {
    dataLayer.emailClick(LocationsEnum.RESET_PASSWORD_FOOTER);
  } else {
    dataLayer.emailClick(LocationsEnum.FOOTER);
  }
}
</script>

<template>
  <footer class="mt-16 bg-grey-50/50 pb-10 pt-4">
    <div class="container space-y-6 p-3 text-grey-500">
      <AppLogo class="h-11" />

      <div class="flex flex-col gap-y-6 md:flex-row md:items-start md:justify-between">
        <div class="order-2 flex flex-row gap-x-2 lg:order-1">
          <LocationTickIcon class="text-[24px] text-brand" />

          <address class="not-italic">
            Vinohradská 2396/184<br>
            130 00 Praha – Vinohrady
          </address>
        </div>

        <div class="order-1 flex flex-col gap-x-8 gap-y-6 md:order-2 md:flex-row md:items-start">
          <div class="flex flex-row gap-x-2">
            <PhoneIcon class="text-[24px] text-brand" />

            <ContactPhoneLink @click:phone="handlePhoneClick" />
          </div>

          <div class="order-1 flex flex-row gap-x-2">
            <MailIcon class="text-[24px] text-brand" />

            <ContactEmailLink @click:email="handleEmailClick" />
          </div>
        </div>

        <div class="order-3 flex flex-row gap-x-4">
          <a
            aria-label="Facebook"
            class="flex size-10 items-center justify-center rounded-full bg-brand"
            href="https://www.facebook.com/srovnavacdluhopisu/"
            target="_blank"
          >
            <FacebookIcon class="text-[20px] text-white" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
